import { rootStore } from '../stores/rootStore';
import { CookieUtils } from './cookies';

const withErrorHandler = async <T>(cb: () => Promise<T | undefined>) => {
  try {
    const res = await cb();
    return res;
  } catch (error) {
    if (error instanceof Error) {
      rootStore.errorStore.setError(error);
      return;
    }

    const err = new Error('Неизвестная ошибка');
    err.name = 'Error';
    rootStore.errorStore.setError(err);
  }
};

const handleErrorResponse = async (response: Response) => {
  // handle 500
  if (response.status === 500) {
    const err = new Error();
    err.message = (await response.text()) || 'Что-то пошло не так :(';
    err.name = response.statusText || 'Ошибка сервера';
    throw err;
  }

  if (response.status === 401) {
    // clear cookies
    CookieUtils.clearToken();
    rootStore.authStore.setUser(undefined);

    const error = new Error('Вероятно, вас давно не было. Или пространственно-временной континуум разорвался :)');
    error.name = 'Сессия устарела';
    throw error;
  }

  const err = new Error();
  err.message = (await response.text()) || 'Что-то пошло не так :(';
  err.name = response.statusText || 'Неизвестная ошибка';

  throw err;
};

export const api = {
  hostUrl: import.meta.env.VITE_API_URL,

  post: async function <T>(url: string, bodyRequest: unknown) {
    return withErrorHandler<T>(async () => {
      const token = CookieUtils.getToken();
      const response = await fetch(`${api.hostUrl}${url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token && {
            Authorization: `NLB ${token}`,
          }),
        },
        body: JSON.stringify(bodyRequest),
      });

      if (response.ok) {
        return response.json() as T;
      } else {
        await handleErrorResponse(response);
      }
    });
  },
  get: async function <T>(url: string) {
    return withErrorHandler<T>(async () => {
      const token = CookieUtils.getToken();
      const response = await fetch(`${api.hostUrl}${url}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...(token && {
            Authorization: `NLB ${token}`,
          }),
        },
      });

      if (response.ok) {
        return response.json() as T;
      } else {
        await handleErrorResponse(response);
      }
    });
  },
};
